import { prefixObjectValues } from '../utils';

const notification = {
  layout: 'layout',
  num: 'notification-num-',
  count: 'notification-count',
  message: 'message',
  subject: 'subject',
  icon: 'icon',
  closeBtn: 'closeBtn',
  relTime: 'relTime',
  link: 'link',
  groupToggle: 'groupToggle',
  markAllRead: 'markAllRead',
};

export default prefixObjectValues(notification, 'notifications');
